
import { Component, Vue } from "vue-property-decorator";
import DocumentFields from "@/components/DocumentFields.vue";
import DocumentJoin from "@/components/DocumentJoin.vue";

import "@/assets/css/pages/news.css";
import News from "@/news";
import { Article, Category } from "@/news_articles";

@Component({
  components: { DocumentFields, DocumentJoin },
})
export default class extends Vue {
  selectedCategory: Category | null = null;
  C = Category;
  list: Article[] = [];

  mounted() {
    this.updateSelectedList();
  }

  isActive(cat: Category | null) {
    if (this.selectedCategory === cat) {
      return "active";
    }
    return "";
  }

  async updateSelectedList(): Promise<void> {
    if (this.selectedCategory) {
      this.list = await News.getList(this.selectedCategory);
    } else {
      this.list = await News.getListFromRss();
    }

    return;
  }

  selectCategory(category: Category) {
    this.selectedCategory = category;
    this.updateSelectedList();
  }
}
